module.exports = __webpack_public_path__ + "img/special_ultraDark.6603a7a7.png";